import { Ability, AbilityBuilder } from '@casl/ability';

export default function defineRulesFor(role, email) {
  const { can, cannot, rules } = new AbilityBuilder(Ability);
  if (role === 'admin') {
    can('manage', 'all');
    can('configure', 'IRTH');
  } else {
    cannot('create', 'client');
    cannot('delete', 'client');

    cannot('delete', 'user', { email });

    cannot('update', 'finding');
    cannot('accessAll', 'finding');

    cannot('delete', 'mission');
    can('create', 'mission');

    cannot('downloadErrorCsv', 'patrol');
    cannot('publish', 'patrol');
    cannot('delete', 'patrol');
  }
  return rules;
}

export function buildAbilityFor(role, email) {
  return new Ability(defineRulesFor(role, email));
}
